import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../store';
import {
    CREATE_FAQ,
    DELETE_FAQ,
    GET_FAQ_LIST,
    UPDATE_FAQ,
} from '../../actions/faq/thunks';

const selectRoot = ({ faq }: RootState) => faq;

const selectRootLoader = ({ loaders }: RootState) => loaders;

export const selectGetFaqListLoader = createSelector(
    selectRootLoader,
    loaders => loaders[GET_FAQ_LIST],
);

export const selectCreateFaqLoader = createSelector(
    selectRootLoader,
    loaders => loaders[CREATE_FAQ],
);

export const selectUpdateFaqLoader = createSelector(
    selectRootLoader,
    loaders => loaders[UPDATE_FAQ],
);

export const selectDeleteFaqLoader = createSelector(
    selectRootLoader,
    loaders => loaders[DELETE_FAQ],
);

export const selectFaqList = createSelector(
    selectRoot,
    ({ faqList }) => {
        console.log(faqList);
        return faqList || [];
    },
);
